import React, { Suspense, useState } from 'react'
import { FilterSearch as FilterIcon } from '@refera/ui-icons'
import { Button } from '@refera/ui-web'
import Theme from '@refera/ui-core'

import { Grid, InputLabel } from '@mui/material'
import { NewServiceOrderButton } from '../../../management-service-order/new-service-order-button'
import SwitchComponent from '_/components/switch'

import useStyles from './styles'
import { useSelector } from 'react-redux'
import { userSelector } from '_/modules/authentication/selectors'
import { useUrlParams } from '../../../../hooks/use-url-params'

const KanbanFilters = React.lazy(() =>
  import('../filters').then(module => ({ default: module.KanbanFilters }))
)

export function HeaderButtons() {
  const styles = useStyles()
  const { updateParam } = useUrlParams()

  const user = useSelector(userSelector)

  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false)
  const [seeOnlyMyServiceOrders, setSeeOnlyMyServiceOrders] = useState(
    user?.viewOnlyMyCompanyTickets
  )

  const [seeOlderServiceOrdersFirst, setSeeOlderServiceOrdersFirst] = useState(
    user?.params?.kanbanOlderServiceOrdersFirst
  )

  function toggleSeeOlderServiceOrdersFirst() {
    setSeeOlderServiceOrdersFirst(prev => {
      const newValue = !prev
      updateParam({ paramName: 'olderFirst', paramValue: newValue })
      return newValue
    })
  }

  function toggleSeeOnlyMyServiceOrders() {
    setSeeOnlyMyServiceOrders(prev => {
      const newValue = !prev
      updateParam({ paramName: 'viewOnlyMyCompanyTickets', paramValue: newValue })
      return newValue
    })
  }

  function OlderServiceOrdersFirstSwitch() {
    return (
      <Grid className={styles.onlyMyOrdersContainer}>
        <InputLabel
          htmlFor="older-service-orders-first-switch"
          className={styles.onlyMyOrdersLabel}
        >
          Mais antigos primeiro
        </InputLabel>
        <SwitchComponent
          id="older-service-orders-first-switch"
          checked={seeOlderServiceOrdersFirst}
          onChange={toggleSeeOlderServiceOrdersFirst}
        />
      </Grid>
    )
  }

  function OnlyMyOrdersSwitch() {
    return (
      <Grid className={styles.onlyMyOrdersContainer}>
        <InputLabel htmlFor="only-my-orders-switch" className={styles.onlyMyOrdersLabel}>
          Só meus chamados
        </InputLabel>
        <SwitchComponent
          id="only-my-orders-switch"
          checked={seeOnlyMyServiceOrders}
          onChange={toggleSeeOnlyMyServiceOrders}
        />
      </Grid>
    )
  }

  function toggleFilterDrawerState() {
    setFilterDrawerOpen(prev => !prev)
  }

  function FiltersButton() {
    return (
      <Button
        variant="ghost"
        startIcon={<FilterIcon color={Theme.Colors.Primary.Base} />}
        onClick={toggleFilterDrawerState}
      >
        Filtros
      </Button>
    )
  }

  return (
    <Grid className={styles.container}>
      <OlderServiceOrdersFirstSwitch />
      <OnlyMyOrdersSwitch />
      <NewServiceOrderButton />
      <FiltersButton />
      {filterDrawerOpen && (
        <Suspense>
          <KanbanFilters open={filterDrawerOpen} close={toggleFilterDrawerState} />
        </Suspense>
      )}
    </Grid>
  )
}
